/**
 * "Editing another vehicle discards the draft you started."
 *
 * Editing needs a clean store, so it necessarily throws away an in-progress
 * CREATE draft. That is a real cost — up to 17 live captures and a document scan
 * — so it is never silent: keeping the draft cancels the edit, discarding is
 * explicit, and back/Esc/backdrop only close.
 */
import { useTranslation } from 'react-i18next'
import { ConfirmDialog } from '@/components/ui/ConfirmDialog'

interface EditDiscardsDraftDialogProps {
  visible: boolean
  /** Cancel the edit; the draft is untouched. */
  onKeepDraft: () => void
  /** Discard the draft (state AND files) and open the listing for editing. */
  onDiscardAndEdit: () => void
  /** Back / Esc / backdrop: close, destroy nothing. */
  onDismiss: () => void
  testIDPrefix: string
}

export function EditDiscardsDraftDialog({
  visible,
  onKeepDraft,
  onDiscardAndEdit,
  onDismiss,
  testIDPrefix,
}: EditDiscardsDraftDialogProps) {
  const { t } = useTranslation()
  return (
    <ConfirmDialog
      visible={visible}
      title={t('hosting.resume_draft_title')}
      message={t('hosting.edit_discards_draft_body')}
      confirmLabel={t('hosting.resume_draft_continue')}
      cancelLabel={t('hosting.edit_discard_and_edit')}
      destructive={false}
      onConfirm={onKeepDraft}
      onCancel={onDiscardAndEdit}
      onDismiss={onDismiss}
      testIDs={{
        overlay: `${testIDPrefix}.edit-discard-dialog`,
        confirm: `${testIDPrefix}.edit-keep-draft`,
        cancel: `${testIDPrefix}.edit-discard`,
      }}
    />
  )
}
